import { useEffect } from 'react';
import { ProductCard } from '../../components/shop/ProductCard';
import { ShopLanguage } from '../../components/shop/ShopElements';
import { useShop } from '../../components/shop/useShop';
import '../../components/shop/shop.css';

export default function FichesLumiere() {
  const shop = useShop();
  const { t, lang, flash, setFlash, products: shopProducts } = shop;
  const sheets = shopProducts.filter(p => p.kind === 'sheet' && (!flash || p.flash_counts.includes(flash)));
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return <div className="shop-container" lang={lang} data-testid="shop-page">
    <header className="shop-heading">
      <div className="shop-heading-top"><p className="shop-eyebrow">{t.collection}</p><ShopLanguage shop={shop}/></div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl" data-testid="shop-title">{t.title}<span aria-hidden="true">.</span></h1>
      <p className="shop-intro" data-testid="shop-intro">{t.intro}</p>
      <div className="shop-notice" data-testid="shop-preview-notice"><span className="shop-status-dot" aria-hidden="true"/>
        <p><strong>{shop.salesEnabled ? t.launched : t.preview}</strong><span>{shop.salesEnabled ? t.launchedNote : t.pending}</span></p>
      </div>
    </header>
    <section aria-label={t.selection} className="shop-featured" data-testid="shop-featured">
      {shopProducts.filter(p => p.kind !== 'sheet').map(product => <ProductCard key={product.id} product={product} shop={shop} featured/>)}
    </section>
    <section aria-labelledby="shop-sheets-heading" className="shop-sheets">
      <div className="shop-sheets-heading"><h2 id="shop-sheets-heading" className="text-base md:text-lg">{t.single}</h2>
        <span role="status" aria-live="polite" data-testid="shop-result-count">{t.count(sheets.length)}</span>
      </div>
      <div role="group" aria-label={t.filters} className="shop-filters" data-testid="shop-filters">
        {[0, 1, 2, 3, 4, 5].map(n => <button type="button" key={n} onClick={() => setFlash(n)} aria-pressed={flash === n} data-testid={`shop-filter-${n}`}>
          {n ? t.flash(n) : t.all}
        </button>)}
      </div>
      <div className="shop-grid" data-testid="shop-products">
        {sheets.map(product => <ProductCard key={product.id} product={product} shop={shop}/>)}
      </div>
    </section>
    <p className="shop-ai-note" data-testid="shop-ai-disclosure">{t.ai}</p>
  </div>;
}